/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2020-08-07 09:04:17
 * @LastEditors: snzo.chen
 * @LastEditTime: 2021-10-12 15:32:46
 */
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AnyJson } from './data-types/common.types';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) private plateformId: object) {
    this.isBrowser = isPlatformBrowser(this.plateformId);
  }
  getStorage(key: string, type = 'local'): string {
    if (this.isBrowser) {
      return window[type + 'Storage'].getItem(key);
    } else {
      return '';
    }
  }
  setStorage(params: AnyJson | AnyJson[], type = 'local'): void {
    if (this.isBrowser) {
      const kv = Array.isArray(params) ? params : [params];
      for (const { key, value } of kv) {
        window[type + 'Storage'].setItem(key, value.toString());
      }
    }
  }
  removeStorage(params: string | string[], type = 'local'): void {
    if (this.isBrowser) {
      const kv = Array.isArray(params) ? params : [params];
      for (const key of kv) {
        window[type + 'Storage'].removeItem(key);
      }
    }

  }
}
